<template>
    <div style="border: 1px solid #ccc;">
        <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
        />
        <Editor
            style="height: 200px; overflow-y: hidden;"
            v-model="html"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
            @onChange="onChange"
        />
    </div>
</template>
<script>
  import Vue from 'vue'
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { uploadfile } from "@/api/index.js"
  export default Vue.extend({
    components: { Editor, Toolbar },
    props:{
      value:{
        type:String,
        default:''
      }
    },
    data() {
      return {
        editor: null,
        html: '<p>hello</p>',
        toolbarConfig: {
          //排除的
          excludeKeys:[
            'insertVideo','emotion','insertLink','code','codeBlock','todo','uploadVideo','editVideoSize','group-video','fullScreen'
          ],
        },
        editorConfig: { 
          placeholder: '请输入内容...',
           MENU_CONF: {
                uploadImage: {
                   customUpload: async (file, insertFn) => {
                      let formData = new FormData();
                      formData.append("file", file);
                      let obj=await uploadfile(formData)
                      insertFn(this.$imgurl(obj.data.url), '', this.$imgurl(obj.data.url))
                    },
                },
              }
         },
        mode: 'default', // or 'simple',default
      }
    },
    methods: {
      imgurl(url){
        this.$imgurl(url)
      },
      onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        this.html=this.value
        // console.log(this.editor.getConfig())
      },
       onChange(editor) {
          // console.log("onChange", editor.getHtml()); // onChange 时获取编辑器最新内容
          this.$emit('input',editor.getHtml())
        },
    },
   
    beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
    },
  })
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
